module.exports = __webpack_public_path__ + "static/media/xela.74c74ec1.jpg";